import React, { FC } from 'react';
import { Badge } from 'reactstrap';
import { Order } from '../../../../../../shared/orders/model';
import { MaterialIcon } from '../../../../../components';
import { useTranslation } from '../../../../../translations';
import { getOrderStatuses, OrderStatusInfo } from '../utils';

interface OrderListItemProps {
  readonly order: Order;
}

export const OrderListItem: FC<OrderListItemProps> = ({ order }) => {
  const { ts } = useTranslation();
  return (
    <div className="table-item" id={`order${order.id}`}>
      <MaterialIcon className="icon" large name="receipt" />
      <p>
        {ts('common.order')} #{order.id} &mdash; {order.orderItems.length} {ts('common.items')}
      </p>
      <p className="badge-list small">
        <OrderBadges order={order} />
      </p>
    </div>
  );
};

export const OrderBadges: FC<OrderListItemProps> = ({ order }) => {
  const { ts } = useTranslation();
  const statuses = getOrderStatuses(order);
  const badges: React.JSX.Element[] = [];

  for (const status of statuses) {
    switch (status) {
      case OrderStatusInfo.Paid: {
        badges.push(
          <Badge color="success" key="paid">
            {ts('common.paid')}
          </Badge>,
        );

        break;
      }

      case OrderStatusInfo.Unpaid: {
        badges.push(
          <Badge color="danger" key="unpaid">
            {ts('common.unpaid')}
          </Badge>,
        );

        break;
      }

      case OrderStatusInfo.Cancelled: {
        badges.push(
          <Badge color="secondary" key="cancelled">
            {ts('common.cancelled')}
          </Badge>,
        );

        break;
      }

      case OrderStatusInfo.PartiallyRefunded: {
        badges.push(
          <Badge color="info" key="partiallyRefunded">
            {ts('common.partially_refunded')}
          </Badge>,
        );

        break;
      }

      case OrderStatusInfo.Refunded: {
        badges.push(
          <Badge color="info" key="refunded">
            {ts('order_list_item.refunded')}
          </Badge>,
        );

        break;
      }

      case OrderStatusInfo.RequiresFulfillment: {
        badges.push(
          <Badge color="warning" key="requiresFulfillment">
            {ts('order_list_item.requires_fulfillment')}
          </Badge>,
        );

        break;
      }

      case OrderStatusInfo.PartiallyFulfilled: {
        badges.push(
          <Badge color="warning" key="partiallyFulfilled">
            {ts('order_list_item.requires_partial_fulfillment')}
          </Badge>,
        );

        break;
      }

      case OrderStatusInfo.Fulfilled: {
        badges.push(
          <Badge color="success" key="fulfilled">
            {ts('common.fulfilled_question')}
          </Badge>,
        );

        break;
      }
    }
  }

  return badges;
};
